"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SBase = __importStar(require("./base.styled"));
var Messages = function (props) {
    var _a, _b, _c;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !((_a = props.error) === null || _a === void 0 ? void 0 : _a.message) && (props === null || props === void 0 ? void 0 : props.warningMessage) !== undefined && (react_1.default.createElement(SBase.WarningMessage, null, props.warningMessage)),
        !props.disabled &&
            !props.readOnly &&
            ((_b = props === null || props === void 0 ? void 0 : props.error) === null || _b === void 0 ? void 0 : _b.message) !== undefined && (react_1.default.createElement(SBase.ErrorMessage, null, (_c = props.error) === null || _c === void 0 ? void 0 : _c.message))));
};
exports.default = Messages;
